export default "__VITE_ASSET__DLx4Octl__"